import { Box } from "@mui/system";
import StatsCard from "./StatsCard";
import useLeaderboardProps from "hooks/useLeaderboardProps";

const { Toolbar, Tooltip } = require("@mui/material");
import Slide from "@mui/material/Slide";
import { getFloatValue } from "helpers/format";
import useLeaderboardData from "hooks/useLeaderboardData";

const StatsToolbar = () => {
  const { viewType } = useLeaderboardProps();
  const {leaderboardTotals} = useLeaderboardData()
  const shouldRender = viewType === "rank";

  return (
    <>
      {shouldRender ? (
        <Slide in={shouldRender} direction="down">
          <Toolbar variant="dense" sx={{ position: "relative", top: "10px" }}>
            <StatsCard
              title="Flagged Hours"
              value={leaderboardTotals?.flaggedLaborTotal}
            />
            <Box flexGrow={1} />
              <StatsCard
                title="Ready Hours"
                value={leaderboardTotals?.readyLaborTotal}
                tooltipText={"Total Hours for Completed Jobs"}
              />
            <Box flexGrow={1} />
            <StatsCard
              title="Delivered Hours"
              value={leaderboardTotals?.deliveredLaborTotal}
            />
            <Box flexGrow={1} />

            <StatsCard
              title="Overall Efficiency"
              value={`${getFloatValue(
                leaderboardTotals?.efficiency?.efficiency
              )}%`}
            />
          </Toolbar>
        </Slide>
      ) : null}
    </>
  );
};

export default StatsToolbar;
